import React from "react";
import { connect } from "react-redux";
import { Translation } from "react-i18next";
import MediaQuery from "react-responsive";
import queryString from "query-string";
import SharedModal from "../../../../../shared/Modal";

// react-accessible-accordion: Accessible Accordion component
import { Accordion, AccordionItem, AccordionItemHeading, AccordionItemButton } from "react-accessible-accordion";
import CategoryItem from "./CategoryItem";
import { CATEGORY_SELECTED, CATEGORY_NAV_URL_UPDATE } from "../CategoryNavRedux/CategoryNavActionTypes";
import { LIST_DATA_ASYNC } from "../../../SearchService/SearchDataServiceActionTypes";
import { RESET_PAGE_NUMBER } from "../../../SearchService/SearchDataServiceActionTypes";
import AppSettings from "../../../../../core/AppSettings";

/**************************************************************/
//          CategoryItems Component
/**************************************************************/
class CategoryItems extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            fitmentErrorActive: false,
            expandedIds: this.getInitialExpandedIds(props)
        };
        this.closeAccordion = this.closeAccordion.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.handleAccordionChange = this.handleAccordionChange.bind(this);
    }

    getInitialExpandedIds(props) {
        const { categories, currentCategory } = props;
        let expanded = [];
        if (!categories || !categories.categories) return expanded;
        let queryParams = queryString.parse(document.location.search);
        // Parent (All Categories)
        if (currentCategory.uniqueId === categories.uniqueId || queryParams.categoryId === categories.uniqueId) {
            expanded.push(categories.uniqueId);
        }
        // Children
        categories.categories.forEach((cat) => {
            if (
                currentCategory.uniqueId === cat.uniqueId ||
                queryParams.categoryId === cat.uniqueId ||
                (cat.subCategories &&
                    cat.subCategories.some(
                        (sub) => currentCategory.uniqueId === sub.uniqueId || queryParams.categoryId === sub.uniqueId
                    ))
            ) {
                expanded.push(cat.uniqueId);
            }
        });
        return expanded;
    }

    componentDidUpdate(prevProps) {
        //determine which tagging classes should be active in the category links, dependant on if there's a fitment issue
        const fitmentErrorElement = document.getElementsByClassName("ac-errorParent");
        if (!this.state.fitmentErrorActive && fitmentErrorElement.length) {
            this.setState({ fitmentErrorActive: true });
        }
        // Sync expandedIds if currentCategory changes
        if (prevProps.currentCategory !== this.props.currentCategory) {
            this.setState({ expandedIds: this.getInitialExpandedIds(this.props) });
        }
    }

    handleAccordionChange(expandedIds) {
        const prevExpanded = this.state.expandedIds || [];
        this.setState({ expandedIds });
        const categories = this.props.categories;
        if (!categories) return;
        // If a category was just collapsed (i.e., went from open to closed)
        const collapsed = prevExpanded.find((id) => !expandedIds.includes(id));
        if (collapsed && collapsed !== categories.uniqueId) {
            // Trigger 'All Categories' search
            this.props.handleURL(categories);
            this.props.selectCategory(categories, this.props.searchParams);
            return;
        }
        // If a category was just expanded
        const newlyExpanded = expandedIds.find((id) => !prevExpanded.includes(id));
        if (newlyExpanded) {
            let selectedCat = null;
            if (newlyExpanded === categories.uniqueId) {
                selectedCat = categories;
            } else if (categories.categories) {
                selectedCat = categories.categories.find((cat) => cat.uniqueId === newlyExpanded);
            }
            if (selectedCat) {
                this.props.handleURL(selectedCat);
                this.props.selectCategory(selectedCat, this.props.searchParams);
            }
        }
    }

    /**
     * responsible for creating the categories that serve as the accordion for the subcategories
     *  */
    createCategories() {
        const categories = this.props.categories;
        if (!categories || !categories.categories) return <div />;
        const allCategories = categories;
        const categoryMap = allCategories.categories;
        return (
            <>
                <AccordionItem uuid={allCategories.uniqueId} className="q-expander">
                    <AccordionItemHeading className="ac-accordion-title ac-parent-expander q-headline q-expander-button" >
                        <AccordionItemButton className="ac-category-link">
                            <h5>
                                <span className="ac-category-link">
                                    {allCategories.label} ({allCategories.count})
                                </span>
                            </h5>
                        </AccordionItemButton>
                    </AccordionItemHeading>
                </AccordionItem>
                {categoryMap.map((category, i) => (
                    <CategoryItem
                        key={category.uniqueId}
                        uuid={category.uniqueId}
                        closeAccordion={this.closeAccordion}
                        category={category}
                        fitmentErrorActive={this.state.fitmentErrorActive}
                        currentCategory={this.props.currentCategory}
                        selectCategory={this.props.selectCategory}
                        id={category.uniqueId}
                        searchParams={this.props.searchParams}
                        selected={this.state.selections}
                        handleURL={this.props.handleURL}
                        allCategories={allCategories}
                    />
                ))}
            </>
        );
    }

    closeAccordion() {
        this.setState({ showModal: false });
    }

    toggleModal() {
        this.setState((prevState) => ({ showModal: !prevState.showModal }));
    }

    render() {
        const categories = this.createCategories();

        //mobile nav includes a button and is hidden unless selected
        const mobileNav = (
            <Translation>
                {(t) => (
                    <React.Fragment>
                        <div className="ac-mobile-catnav-btn">
                            <button
                                className="q-button q-secondary-button stat-button-link"
                                type="button"
                                data-dtm={this.state.fitmentErrorActive ? "all fitted products" : "all products"}
                                onClick={this.toggleModal}
                            >
                                {t("LABEL_SEARCH_SHOP_CATEGORY")}
                            </button>
                        </div>

                        <SharedModal open={this.state.showModal} onClose={this.closeAccordion} centered>
                            <div>
                                <h2 className="q-headline2">{t("LABEL_SEARCH_SHOP_CATEGORY")}</h2>
                                {categories}
                            </div>
                        </SharedModal>
                    </React.Fragment>
                )}
            </Translation>
        );

        //desktop nav
        const desktopNav = (
            <Accordion
                allowZeroExpanded
                preExpanded={this.state.expandedIds}
                onChange={this.handleAccordionChange}
                className="ac-accordion"
            >
                {categories}
            </Accordion>
        );

        return (
            <Translation>
                {(t) => (
                    <div>
                        <MediaQuery query="(max-width: 59.99em)">{mobileNav}</MediaQuery>
                        <MediaQuery query="(min-width: 60em)">{desktopNav}</MediaQuery>
                    </div>
                )}
            </Translation>
        );
    }
}

/**************************************************************/
//          Map Dispatch to Props
/**************************************************************/
function mapDispatchToProps(dispatch) {
    return {
        selectCategory: (category, searchParams) => {
            dispatch({
                type: CATEGORY_SELECTED,
                payload: { selectedCategory: category }
            });
            dispatch({
                type: RESET_PAGE_NUMBER
            });
            dispatch({
                type: LIST_DATA_ASYNC,
                payload: {
                    year: searchParams.year,
                    make: searchParams.make,
                    model: searchParams.model,
                    categoryId: category.uniqueId
                }
            });
        },
        /* takes the currently selected category and passes it to the URL updater
         * used in this file, CategoryItem.js and SubCategoryItem.js */
        handleURL: (category) => {
            dispatch({
                type: CATEGORY_NAV_URL_UPDATE,
                category: category
            });
        }
    };
}

export default connect(null, mapDispatchToProps)(CategoryItems);
